import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../../lib/api";
import { useAuth, STAFF_ROLES } from "../../context/AuthContext";

/* Handles Emergent Google OAuth redirect: exchanges session_id (URL fragment) for a session.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const consent = (() => { try { const v = localStorage.getItem("cf_marketing_consent"); localStorage.removeItem("cf_marketing_consent"); return v === "1"; } catch (e) { return false; } })();
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, marketing_consent: consent });
        applyAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(STAFF_ROLES.includes(data.user.role) ? "/admin" : "/dashboard", { replace: true });
      } catch {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [navigate, applyAuth]);

  return (
    <div className="min-h-screen cf-bg grid place-items-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        {error ? (
          <p className="text-firered">{error}</p>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-gold" />
            <span className="text-sm">Completing sign-in…</span>
          </>
        )}
      </div>
    </div>
  );
}
